import React, { createContext, useState, useContext, useCallback } from "react";

const PackagesModalContext = createContext();

export const usePackagesModal = () => useContext(PackagesModalContext);

export const PackagesModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [errorData, setErrorData] = useState(null);

  const showPackages = useCallback((data = null) => {
    setErrorData(data);
    setIsOpen(true);
  }, []);

  const hidePackages = useCallback(() => {
    setIsOpen(false);
    setErrorData(null);
  }, []);

  return (
    <PackagesModalContext.Provider
      value={{
        isOpen,
        errorData,
        showPackages,
        hidePackages,
      }}
    >
      {children}
    </PackagesModalContext.Provider>
  );
};
